const TokenKey = 'Admin-Token'

export function getToken() {
  return localStorage.getItem('token') //localStorage(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem('token', token)
}

export function removeToken() {
  return localStorage.clear('token')
}
export function getUser() {
  if (JSON.parse(localStorage.getItem('userInfo'))) {
    return JSON.parse(localStorage.getItem('userInfo'))
  } else {
    return {}
  }

}

export function setUser(userInfo) {
  return localStorage.setItem('userInfo', JSON.stringify(userInfo))
}

export function removeUser() {
  return localStorage.clear('userInfo')
}
